<script>
	import { goto } from '$app/navigation';
	import { popupModalOpen } from '$lib/popups/popupsStore';
	import { isUserEligibleForNewYearOrb } from '../store';

	const handleRedirectToOrbPage = () => {
		popupModalOpen.set(false);
		goto('/mystery-orbs');
	};

	$: orbTier = $isUserEligibleForNewYearOrb.tier || '';
</script>

<div
	class="w-[308px] flex p-5 flex-col items-center gap-6 justify-center rounded-2xl border-[1px] border-solid border-fx-grey-500 bg-fx-gradient-8 overflow-hidden"
>
	<div
		class="w-full flex justify-center items-center flex-col pb-4 z-10 relative border border-[#262626] rounded-2xl bg-fx-gradient-nft-level-card-details"
	>
		<img
			src={`trading-season/MysteryOrbsSection/orbs/${
				orbTier === 'k' ? 'normal' : orbTier === 'j' ? 'rare' : 'legendary'
			}-orb.webp`}
			alt="Mystery Orb"
			loading="lazy"
			class="w-full mb-1"
		/>
		<p class="text-sm text-fx-grey-200 text-center my-2">
			Happy new year king! 👑 <br />
			Here's a gift from Polynomial to you.
		</p>
		<p class="text-fx-gradient-17 text-2xl leading-[30px] font-semibold">Mystery Orb</p>
	</div>
	<div class="h-[1px] bg-fx-grey-600 w-full" />
	<div class="flex justify-center items-center w-full gap-2.5">
		<button
			class="w-full bg-fx-gradient-5 rounded-xl flex justify-center items-center py-[18px]"
			on:click={handleRedirectToOrbPage}
		>
			<p class="text-base font-semibold text-fx-black">Check Your Orb</p>
		</button>
	</div>
</div>
